import { Link } from 'react-router-dom';
import Metadata from '../components/Metadata';

export default function Forbidden() {
  return (
    <>
      <Metadata
        title="403 - Adgang nægtet - K. Pheiffer Construction"
        description="Du har ikke adgang til denne side. Gå tilbage til forsiden af K. Pheiffer Construction."
      />

      <section className="min-h-[70vh] flex items-center justify-center bg-white px-4 py-16 sm:py-24">
        <div className="text-center max-w-md mx-auto">
          <div className="h-20 w-20 bg-red-50 text-red-600 rounded-full flex items-center justify-center mx-auto mb-6 border border-red-100">
            <i className="fa-regular fa-lock text-3xl" />
          </div>
          <span className="text-xs font-bold uppercase tracking-widest text-red-600">Fejlkode 403</span>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 mt-2">
            Adgang nægtet
          </h1>
          <p className="mt-4 text-slate-500 text-sm sm:text-base leading-relaxed">
            Du har desværre ikke de nødvendige rettigheder til at få adgang til denne side eller ressource.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center justify-center rounded bg-slate-900 hover:bg-slate-800 text-white px-6 py-3 text-sm font-semibold tracking-wide transition-colors"
            >
              Gå til forsiden
            </Link>
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center rounded border border-slate-200 hover:border-slate-900 text-slate-700 hover:text-slate-900 px-6 py-3 text-sm font-semibold tracking-wide transition-colors"
            >
              Kontakt os
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
